export default __webpack_public_path__ + "static/media/49.99d0c9a2.jpeg";